module.exports = __webpack_public_path__ + "img/book.1945e803.svg";